import { motion } from "framer-motion";
import EmailSignup from "./EmailSignup";

const CTASection = () => {
  return (
    <section className="py-24 md:py-32 relative">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_hsl(43_72%_55%_/_0.06),_transparent_60%)]" />

      <div className="container mx-auto px-6 md:px-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl mx-auto text-center space-y-8"
        >
          <p className="text-xs uppercase tracking-[0.4em] text-gold font-body font-medium">
            Don't Miss This
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground leading-tight">
            Your legacy starts with<br />
            <span className="text-gradient-gold">a single decision.</span>
          </h2>
          <p className="text-muted-foreground font-body text-base md:text-lg leading-relaxed">
            Enrollment is now open for the Wealth Transfer Academy.
            Join the academy and step into your next chapter.
          </p>

          <div className="flex justify-center">
            <EmailSignup />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
